import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper" }

import { onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

import { ArticleView } from '@/models/doc.article'
import DocExport from '@/app/components/doc/DocExport.vue'
import Layout from '@/app/components/Layout.vue'
import LoadingError from '@/components/ui/LoadingError.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleExportPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const article = ref<ArticleView>()
const isError = ref(false)

onBeforeMount(async () => {
  const urlSlug = route.params.url_slug as string
  try {
    const docData = await backend.getArticle(urlSlug)
    const userData = await backend.getDocUserData(docData.id)
    article.value = new ArticleView(docData, userData)
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      router.push({ name: 'not_found' })
    } else {
      isError.value = true
      Sentry.captureException(error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (article.value)
    ? (_openBlock(), _createBlock(DocExport, {
        key: 0,
        doc: article.value
      }, null, 8, ["doc"]))
    : (isError.value)
      ? (_openBlock(), _createBlock(Layout, {
          key: 1,
          "show-upgrade-prompt-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(LoadingError)
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(Layout, {
          key: 2,
          "show-upgrade-prompt-modal": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_loading_spinner)
            ])
          ]),
          _: 1
        }))
}
}

})